import { StringBundle } from '../localizer/stringBundle'

export const strings = {
  bundles: [StringBundle.ATF, StringBundle.BTF],
  strings: [
    'DV_DP_first_review',
    'DV_DP_ARIA_amazon_rating',
    'DV_DP_ARIA_imdb_rating',
    'DV_DP_ARIA_watch_episode',
    'DV_DP_ARIA_watch_title',
    'DV_DP_ARIA_audio_description',
  ] as const,
}
